import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";

import {AuditDetalhe} from "./audit-detalhe";
import {DatePipe} from "@angular/common";
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {handleError} from "../shared/util/error-util";

@Injectable({
    providedIn: 'root'
})
export class TrilhaAuditoriaService {


    private readonly url = '/v1/auditorias';
    private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

    constructor(
        private readonly datePipe: DatePipe,
        private readonly httpClient: HttpClient
    ) {
    }

    search(value: any): Observable<any> {
        const headers = this._httpHeaders;
        let params = this.createFormParam(value);
        params = params.set("size", value.itensPerPage);
        params = params.set("page", value.page);


        const options = {headers};
        return this.httpClient.get<any>(`${this.url}?${params.toString().replace(/\+/gi, '%2B')}`, options);// httpclient substitui + com espaço()
    }

    exportPdf(value: any): Observable<HttpResponse<Blob>> {
        const headers = this._httpHeaders;
        const params = this.createFormParam(value).set("size", '99999999');
        return this.httpClient.get(`${this.url}/export/pdf`,
            {headers, responseType: "blob", observe: "response", params}).pipe(catchError(handleError));
    }

    exportXlsx(value: any): Observable<HttpResponse<Blob>> {
        const headers = this._httpHeaders;
        const params = this.createFormParam(value).set("size", '99999999');
        return this.httpClient.get(`${this.url}/export/xlsx`,
            {headers, responseType: "blob", observe: "response", params}).pipe(catchError(handleError));
    }

    private createFormParam(value: any) {

        let params: HttpParams = new HttpParams();
        if (value.dataInicio && value.dataInicio !== '') {
            params = params.set('inicio', this.datePipe.transform(value.dataInicio, 'yyyy-MM-dd'));
        }
        if (value.dataFim && value.dataFim !== '') {
            params = params.set('fim', this.datePipe.transform(value.dataFim, 'yyyy-MM-dd'));
        }
        const keys = Object.keys(value);
        keys.forEach(key =>{
            if(value[key] && value[key] !== ''){
                params = params.set(key,value[key]);
            }
        })

        return params;
    }

    findDetails(idAuditoria: any, tipoCadastro: string): Observable<AuditDetalhe> {
        const headers = this._httpHeaders;
        const params: HttpParams = new HttpParams().append('majorId', idAuditoria.majorId).append('minorId', idAuditoria.minorId).append('tipoCadastro', tipoCadastro);
        return this.httpClient.get<AuditDetalhe>(`${this.url}/details`, {headers, params})
    }

    findPreviousDetails(description: string, tipoCadastro: string): Observable<AuditDetalhe> {
        const headers = this._httpHeaders;
        const params: HttpParams = new HttpParams().append('description', description).append('tipoCadastro', tipoCadastro);
        return this.httpClient.get<AuditDetalhe>(`${this.url}/previous/details`, {headers, params})
    }

    findAllTipoCadastro(): Observable<string[]> {
        const headers = this._httpHeaders;
        return this.httpClient.get<string[]>(`${this.url}/tipo-cadastros`, {headers})

    }

    findChanges(idAuditoria: any,tipoCadastro: string): Observable<AuditDetalhe> {
        const headers = this._httpHeaders;
        const params: HttpParams =  new HttpParams().append('majorId', idAuditoria.majorId).append('minorId', idAuditoria.minorId).append('tipoCadastro', tipoCadastro);
        return this.httpClient.get<AuditDetalhe>(`${this.url}/changes`, {headers, params});
    }
}
